import { ItemList } from "../../orm";

class AdminSalesList extends ItemList {

  getEntityKey() {
    return "admin/sales";
  }

}

export const adminSalesList = new AdminSalesList("admin_sales__default");

class AdminTotalSalesList extends ItemList {

  getEntityKey() {
    return "admin/sales/get_totals";
  }

}

export const adminTotalSalesList = new AdminTotalSalesList("admin_total_sales__default");

class AdminSalesEventBreakdownList extends ItemList {

  getEntityKey() {
    return "admin/sales/get_event_breakdown";
  }

}

export const adminSalesEventBreakdownList = new AdminSalesEventBreakdownList("admin_sales_event_breakdown__default");
